// ── ChecklistCatalogForm ──
import { B } from "../../../shared/theme";
import { Btn, FInput, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const ChecklistCatalogForm = ({ initial, readOnly }) => {
    const { role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
    const [f, set] = useFreshForm(initial || {
      category:"", name:"", responsibleparty:"", description:"",
      order:"", documentrequired:false, isactive:true
    }, "ChecklistCatalog");
    const ST = ({ title }) => <div style={{ gridColumn:"1/-1", fontSize:11, fontWeight:600, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em", marginTop:18, marginBottom:8, paddingBottom:4, borderBottom:"1.5px solid "+B.cyanLight }}>{title}</div>;

    return <Modal title={readOnly?"View Catalog Item":initial?"Edit Catalog Item":"Add Catalog Item"} onClose={closeModal} wide
      onEdit={readOnly&&role.canManageUsers?()=>{ closeModal(); setModal({type:"checklistcatalog-edit",rec:initial,onDone:modal.onDone}); }:null}>
      <ReadOnlyForm readOnly={readOnly}>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:"0 24px" }}>
          <ST title="Item" />
          <Field label="Category"><FInput value={f.category||""} onChange={set("category")} /></Field>
          <Field label="Name"><FInput value={f.name||""} onChange={set("name")} /></Field>
          <Field label="Responsible Party">
            <FSelect value={f.responsibleparty||""} onChange={set("responsibleparty")} options={["","Underwriter","CFO","Admin","BDO","Credit Committee"]} />
          </Field>
          <Field label="Order"><FInput value={f.order??""} onChange={set("order")} type="number" step="0.1" /></Field>

          <Field label="Description" ><FInput value={f.description||""} onChange={set("description")} /></Field>
          <div /><div /><div />

          <ST title="Flags" />
          <div style={{ gridColumn:"1/-1", display:"flex", gap:28, marginBottom:8 }}>
            <label style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, cursor:"pointer" }}>
              <input type="checkbox" checked={!!f.documentrequired} onChange={e=>set("documentrequired")(e.target.checked)} /> Document Required
            </label>
            <label style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, cursor:"pointer" }}>
              <input type="checkbox" checked={f.isactive!==false} onChange={e=>set("isactive")(e.target.checked)} /> Active
            </label>
          </div>
        </div>
      </ReadOnlyForm>
      {!readOnly&&error&&<div style={{ color:"#993C1D",fontSize:12,marginBottom:8,marginTop:8 }}>{error}</div>}
      <div style={{ display:"flex",gap:8,justifyContent:"flex-end",marginTop:16 }}>
        <Btn onClick={closeModal}>{readOnly?"Close":"Cancel"}</Btn>
        {!readOnly&&<Btn disabled={saving} onClick={()=>saveRec("saveChecklistCatalog",{...f},initial?"Edited":"Added","ChecklistCatalog",(initial?"Updated":"Added")+" catalog item",modal.onDone)} variant="primary">{saving?"Saving...":"Save"}</Btn>}
      </div>
    </Modal>;
  };
